import axios from 'axios';

const instance = axios.create({
  baseURL: ''
});

instance.defaults.headers.post['Content-Type'] = 'application/json';
instance.defaults.headers.get['Access-Control-Allow-Origin'] = '*';
instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export default instance;